// extracted by mini-css-extract-plugin
export default {"hubEvent":"HubEvent_hubEvent__AITEd"};